import React, { Component } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Table } from 'reactstrap';
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis } from 'recharts';
import { toast } from 'react-toastify';
import AutopayModal from './AutopayModal';
import SetupAutopayModal from './SetupAutopayModal';
import PaymentModal from './PaymentModal';

class ConsumerDashboard extends Component {
  state = {
    autopay: false,
    latePayments: 0,
    modal1: false,
    modal2: false,
    modal3: false,
    pastDue: false
  }

  componentDidMount() {
    let url = this.props.location.search;

    if (url === '?pastdue') {
      this.setState({
        pastDue: true,
        latePayments: 2
      });
    }

    if (url === '?autopay') {
      this.setState({ autopay: true });
    }

    if (url === '?error') {
      this.handlePaymentError();
    }
  }

  componentWillUnmount() {
    sessionStorage.setItem('visitedDashboard', true);
  }

  handleModal1 = () => {
    this.setState(prevState => ({
      modal1: !prevState.modal1,
    }));
  }
  handleModal2 = () => {
    this.setState(prevState => ({
      modal2: !prevState.modal2,
    }));
  }
  handleModal3 = () => {
    this.setState(prevState => ({
      modal3: !prevState.modal3,
    }));
  }

  handlePaymentError = () => {
    toast.error(
      <div>
        <h5>There was an error processing your payment</h5>
        <small>Please try again or call us at 800-994-6177</small>
      </div>
    , {autoClose: false});
  }

  render() {
    const { autopay, pastDue, latePayments, modal1, modal2, modal3 } = this.state;
    const visitedDashboard = sessionStorage.getItem('visitedDashboard');
    const PaymentData = [{ name: 'Payments', paid: 29, late: latePayments }];

    return (
      <div className={ `page-dashboard ${ visitedDashboard ? 'noAnimations' : '' }` }>

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col className="text-center text-md-left">
              <h3 className="mb-0">Welcome, Michael!</h3>
              <small><strong>Customer ID:&nbsp;</strong> 1234567</small>
            </Col>
            <Col xs={12} md="auto" className="mt-3 mt-md-0">
              { pastDue ?
                <Row>
                  <Col xs="auto" className="pr-0">
                    <img src="/icons/consumer-status-pastdue.svg" alt="Past Due" />
                  </Col>
                  <Col>
                    <h5 className="mb-0">Call 800-994-6177 or Make A Payment</h5>
                    <small>Avoid negative impact on your credit</small>
                  </Col>
                </Row>
                :
                <Row>
                  <Col xs="auto" className="pr-0">
                    <img src="/icons/consumer-status-current.svg" alt="Current" />
                  </Col>
                  <Col>
                    <h5 className="mb-0">Great work Michael!</h5>
                    <small>You are up to date with your payments</small>
                  </Col>
                </Row>
              }
            </Col>
            <Col xs={12} md="auto" className="text-right justify-content-end ml-md-3 mt-3 mt-md-0">
              <FormGroup className="dropdown-toggle mb-0 input-inline">
                <Input type="select" name="select" id="loanSelection" defaultValue="loan1">
                  <option value="">My Loans</option>
                  <option value="loan1">Loan ID – 1234567</option>
                  <option value="loan2">Loan ID – 2098773</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <Card inverse color="primary">
                <CardBody className="text-center">
                  <h1 style={{ fontSize: 3 + 'rem' }} >$2,705.<small>00</small></h1>
                  <h6>Principal Balance</h6>
                  <Row className="mt-4">
                    <Col className="pr-0">
                      <Card className="pt-2 pb-2">
                        <h6>Next Payment</h6>
                        <h3 className="">$300.<small>00</small></h3>
                        <h6 className="mb-0"><span>Due by 1/28/20</span></h6>
                      </Card>
                    </Col>
                    <Col>
                      <Card className={`pt-2 pb-2 ${ pastDue ? 'bg-white' : '' }`}>
                        <h6 className={ pastDue ? 'text-danger' : '' }>Past Due</h6>
                        <h3 className={ pastDue ? 'text-danger' : '' }>
                          { pastDue ? '$205.00' : '$0' }
                        </h3>
                        <h6 className={`mb-0 ${ pastDue ? 'text-danger' : '' }`}>
                          <span>{ pastDue ? 'Due Now' : 'Up to date' }</span>
                        </h6>
                      </Card>
                    </Col>
                  </Row>
                  { autopay ?
                    <Button color="light" outline className="w-100 mb-1" onClick={this.handleModal2}>
                      <img src="/icons/autopay.svg" alt="" className="mr-1" />
                      Manage Autopay
                    </Button>
                    :
                    <Button color="light" outline className="w-100 mb-1" onClick={this.handleModal3}>
                      <img src="/icons/autopay.svg" alt="" className="mr-1" />
                      Set Up Autopay
                    </Button>
                  }
                  <Button color="light" className="w-100" onClick={this.handleModal1}>
                    <img src="/icons/payment.svg" alt="" className="mr-1" />
                    Make A Payment
                  </Button>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={8}>

              <Card>
                <CardHeader className="text-left">
                  Loan Tracker
                  <a href="/" className={`float-right ${ pastDue ? 'text-danger' : '' }`}>Make A Payment</a>
                </CardHeader>
                <CardBody className="pt-2">
                  <ResponsiveContainer width="100%" height={30}>
                    <BarChart
                      data={PaymentData}
                      layout="vertical"
                      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                      height={15}
                      barSize={15}
                    >
                      <XAxis type="number" height={0} domain={[0, 60]} />
                      <YAxis dataKey="name" type="category" width={0} />
                      <Bar dataKey="paid" stackId="a" fill="#04BC6C" background={{ fill: '#DBE3EB' }} radius={3} />
                      <Bar dataKey="late" stackId="a" fill="#D82027" radius={3} />
                    </BarChart>
                  </ResponsiveContainer>
                  <small className="float-left"><strong>$3,103.44 Paid in Principal</strong></small>
                  <small className="float-right">$6,480.00</small>
                </CardBody>
              </Card>

              <Card>
                <CardHeader className="text-md-left">
                  Last 5 Payments
                  <a href="/" className="d-block d-md-inline float-md-right">View All Payments</a>
                </CardHeader>
                <Table className="mb-0" size="sm" responsive striped borderless>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th className="text-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">02/01/2020</th>
                      <td>Payment Received</td>
                      <td>Processing</td>
                      <td className="text-right"><strong>$505.00</strong></td>
                    </tr>
                    <tr>
                      <th scope="row">01/01/2020</th>
                      <td>Payment Received</td>
                      <td>Completed</td>
                      <td className="text-right"><strong>$505.00</strong></td>
                    </tr>
                    <tr>
                      <th scope="row">12/01/2019</th>
                      <td>Payment Received</td>
                      <td>Completed</td>
                      <td className="text-right"><strong>$505.00</strong></td>
                    </tr>
                    <tr>
                      <th scope="row">11/01/2019</th>
                      <td>Payment Received</td>
                      <td>Completed</td>
                      <td className="text-right"><strong>$505.00</strong></td>
                    </tr>
                    <tr>
                      <th scope="row">10/01/2019</th>
                      <td>Payment Received</td>
                      <td>Completed</td>
                      <td className="text-right"><strong>$505.00</strong></td>
                    </tr>
                  </tbody>
                </Table>
              </Card>

            </Col>
          </Row>

        </Container>

        <PaymentModal isOpen={modal1} toggle={this.handleModal1} />
        <AutopayModal isOpen={modal2} toggle={this.handleModal2} />
        <SetupAutopayModal isOpen={modal3} toggle={this.handleModal3} />

      </div>
    );
  }
}

export default ConsumerDashboard;
